/**
 * The base URL for the Forkify API.
 * @constant {string}
 */
export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes`;

/**
 * The timeout duration for API requests, in seconds.
 * @constant {number}
 */
export const TIMEOUT_SEC = 10;

/**
 * The number of results to display per page.
 * @constant {number}
 */
export const RES_PER_PAGE = 10;

/**
 * The API key for accessing the Forkify API.
 * @constant {string}
 */
export const API_KEY = "786378a9-17fb-4888-b735-553b6c89e880";

/**
 * The duration (in milliseconds) before the modal automatically closes.
 * @constant {number}
 */
export const MODAL_CLOSE_SEC = 2500;
